var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2585 1.49778L20.2333 1.47473C19.7499 1.03322 19.1234 0.790039 18.469 0.790039C17.7355 0.790039 17.0311 1.10057 16.5366 1.64194L7.18568 11.8793C7.10045 11.9726 7.0358 12.0827 6.99583 12.2026L5.8963 15.4988C5.76918 15.8799 5.83298 16.3013 6.06695 16.6261C6.30278 16.9535 6.68271 17.1489 7.08335 17.1489H7.08341C7.25671 17.1489 7.42609 17.1133 7.58674 17.043L10.7703 15.6502C10.8861 15.5996 10.9899 15.5253 11.0751 15.432L20.4261 5.19467C21.3991 4.12945 21.3241 2.47115 20.2585 1.49778ZM8.00297 14.8899L8.64817 12.9557L8.70259 12.8961L9.92545 14.013L9.87104 14.0726L8.00297 14.8899ZM19.0928 3.9768L11.1433 12.6798L9.92046 11.5629L17.8699 2.85981C18.0254 2.68959 18.2382 2.59581 18.4691 2.59581C18.6716 2.59581 18.8656 2.67117 19.0157 2.80829L19.041 2.83134C19.3711 3.13284 19.3943 3.6467 19.0928 3.9768Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4431 9.12015C17.9444 9.12015 17.5402 9.5244 17.5402 10.023V17.6883C17.5402 18.9544 16.5101 19.9845 15.244 19.9845H4.30114C3.035 19.9845 2.00499 18.9544 2.00499 17.6883V6.83434C2.00499 5.56826 3.03506 4.53819 4.30114 4.53819H12.2217C12.7203 4.53819 13.1245 4.13394 13.1245 3.63531C13.1245 3.13667 12.7203 2.73242 12.2217 2.73242H4.30114C2.0393 2.73242 0.199219 4.57256 0.199219 6.83434V17.6883C0.199219 19.9501 2.03936 21.7902 4.30114 21.7902H15.244C17.5058 21.7902 19.3459 19.9501 19.3459 17.6883V10.023C19.346 9.5244 18.9417 9.12015 18.4431 9.12015Z",
    fill: "#E9A5F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_3099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.152344 0.790039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.068e01908d564297074af9e1bb3f716f.svg";
export { ForwardRef as ReactComponent };